import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import classNames from 'clsx';
import * as React from 'react';

import { useBannerShift } from './hooks/useBannerShift';

import * as styles from './BannerWrapper.css';

interface IBannerWrapperProps {
  children: React.ReactChild | React.ReactChild[];
  attributes?: React.HTMLAttributes<HTMLDivElement> & { [key: `data-${string}`]: string };
  onClose?(): void;
}

export const BannerWrapper: React.FC<IBannerWrapperProps> = ({ children, attributes = {}, onClose }) => {
  const bannerRef = React.useRef<HTMLDivElement>(null);

  useBannerShift(bannerRef);

  return (
    <div {...attributes} className={classNames(styles['container'], attributes.className)} ref={bannerRef}>
      {onClose && (
        <button className={styles['close']} data-testid="close" onClick={onClose}>
          <IconActionClose12 />
        </button>
      )}

      {children}
    </div>
  );
};
